import * as React from 'react';
import { createContext, Dispatch, SetStateAction } from 'react';
import { Currency } from '../types/location';

type EditLocationContextInterface = {
  currency: Currency | null;
  setCurrency: Dispatch<SetStateAction<Currency | null>>;
};

export const EditLocationContext = createContext<EditLocationContextInterface>({
  currency: null,
  setCurrency: () => null,
});

interface EditLocationProviderProps {
  children: React.ReactNode;
  value: EditLocationContextInterface;
}

const EditLocationProvider = ({
  children,
  value,
}: EditLocationProviderProps) => {
  return (
    <EditLocationContext.Provider value={value}>
      {children}
    </EditLocationContext.Provider>
  );
};

export default EditLocationProvider;
